import React, { useState } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import api from 'utils/api'
import { fetchUserData } from '../../Manage/actions'
import { useDispatch, useSelector } from 'react-redux'
import { API_ROOT } from '../../constants'
import { showUpgradeCardModal } from 'actions'
import { onUpgradePlan } from 'utils/general'
import { PLANS, ARCHIVE_LIMIT_FREE_PLAN } from 'constants/plans'
import { trashSiteFiles } from '../../services/site'
import CustomModal from 'components/CustomModal/CustomModal'

const ArchiveDeleteModal = ({ show, message, domain, onClose, title }) => {
  const [loadingAction, setLoadingAction] = useState(null)
  const dispatch = useDispatch()

  const { userProfile, archivedSites } = useSelector((state) => state.manage)

  const isFreeUser = !userProfile.productId
  const archivedCount = archivedSites.length

  const handleAction = async (action) => {
    if (action === 'ARCHIVE' && isFreeUser && archivedCount >= ARCHIVE_LIMIT_FREE_PLAN) {
      dispatch(
        showUpgradeCardModal({
          title: 'Upgrade for unlimited archived files',
          desc: 'On the free plan, you can archive up to 3 projects. Our paid plans allow unlimited archives.',
          cta: 'Upgrade now',
          onClick: () => onUpgradePlan({ planId: PLANS.TINY.id, userProfile }, dispatch)
        })
      )
      onClose()
      return
    }
    setLoadingAction(action)
    try {
      if (action === 'DELETE') {
        await trashSiteFiles({
          domain: domain?.subdomain || domain?.link
        })
      } else {
        await api.post(`${API_ROOT}/v3/site/${action.toLowerCase()}`, {
          domain: domain?.subdomain || domain?.link,
          site: domain
        })
      }
      dispatch(fetchUserData(false))
      setLoadingAction(false)
      onClose()
    } catch (err) {
      setLoadingAction(false)
    }
  }

  return (
    <CustomModal
      aria-labelledby="contained-modal-title-vcenter"
      show={show}
      onHide={onClose}
      animation={false}
      centered
      enforceFocus={false}
      mobileCloseButton={true}
    >
      <div className="p-4 pb-2">
        <h4 id="contained-modal-title-vcenter" className="bold color-purple-light">
          {title}
        </h4>
      </div>
      <div className="px-4 py-2 font-18" dangerouslySetInnerHTML={{ __html: message }} />
      <div className="border-0 p-4 d-flex justify-content-end gap-2">
        <Button variant="outline-primary" onClick={() => handleAction('ARCHIVE')} disabled={loadingAction}>
          {loadingAction === 'ARCHIVE' ? <Spinner as="span" animation="border" size="sm" /> : 'Archive'}
        </Button>
        <Button
          variant="primary"
          onClick={() => handleAction('DELETE')}
          disabled={loadingAction}
          data-testid="ArchiveDeleteModal-button-delete"
        >
          {loadingAction === 'DELETE' ? <Spinner as="span" animation="border" size="sm" /> : 'Delete'}
        </Button>
      </div>
    </CustomModal>
  )
}

export default ArchiveDeleteModal
